import ParallaxImage from 'components/ParallaxImage';
import useWindowSize from 'hooks/useWindowSize';
import LAYER_1 from 'assets/img/background/stars/layer1.png';
import LAYER_0 from 'assets/img/background/stars/layer.png';
import LAYER_0_MOBILE from 'assets/img/background/stars/layer_mobile.png';
import LAYER_1_MOBILE from 'assets/img/background/stars/layer1_mobile.png';
import { SCREEN_SIZES } from 'style';

const CustomParallaxImage = () => {
  const { width: windowWidth } = useWindowSize();

  return (
    <ParallaxImage
      layers={
        windowWidth < SCREEN_SIZES.desktop
          ? [LAYER_0_MOBILE, LAYER_1_MOBILE]
          : [LAYER_0, LAYER_1]
      }
      parallaxAmount={250}
      // TODO: refactor ParallaxImage to ts, so passing undefined is not needed.
      bleedColor={undefined}
    />
  );
};

export default CustomParallaxImage;
